
import { Routes, Route } from "react-router-dom";

import Main from "../pages/main";

/* menu itens */
import Howitworks from "../pages/Howitworks";
import Subscription from "../pages/Subscription";

/* novo cliente */
import Register from "../pages/Register";

/* login */
import Login from "../pages/Login";

/* páginas do Painel - Rotas Privadas */
import Panel from "../pages/Panel";
import Agent from "../pages/Agent";
import Account from "../pages/Account";
import Billing from "../pages/Billing";
import Performance from "../pages/Performance";

/* agentes */
import Medical from "../pages/AgentsContent/Medical";
import Aesthetic from "../pages/AgentsContent/Aesthetic";

/* rotas privadas */
import Private from "./Private";

/* internas - adminnistrativas */
import Internal from "../pages/Internal";
import Details from "../pages/Internal/details";



function RoutesApp() {
    return(
        <Routes>
            
            <Route path="/" element={ <Main></Main> }></Route>

            <Route path="/howitworks" element={ <Howitworks></Howitworks> }></Route>
            <Route path="/subscription" element={ <Subscription></Subscription> }></Route>

            <Route path="/register" element={ <Register></Register> }></Route>

            <Route path="/login" element={ <Login></Login> }></Route>

            <Route path="/internal" element={ <Internal></Internal> }></Route>
            <Route path="/details" element={ <Details></Details> }></Route>

            {/* rotas privadas */}
            <Route path="/panel" element={ <Private><Panel></Panel></Private> }></Route>
            <Route path="/agent" element={ <Private><Agent></Agent></Private> }></Route>
            <Route path="/medical" element={ <Private><Medical></Medical></Private> }></Route>
            <Route path="/aesthetic" element={ <Private><Aesthetic></Aesthetic></Private> }></Route>
            <Route path="/account" element={ <Private><Account></Account></Private> }></Route>
            <Route path="/billing" element={ <Private><Billing></Billing></Private> }></Route>
            <Route path="/performance" element={ <Private><Performance></Performance></Private> }></Route>
            
        </Routes>
    )
}

export default RoutesApp;